import { motion } from 'framer-motion';
import { Instagram, Facebook, Youtube, Heart } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_beauty-training-5/artifacts/yey6sygd_ritha%20barreto%20logo%20nova%202.png";

const socialLinks = [
  { icon: Instagram, href: '#', label: 'Instagram' },
  { icon: Facebook, href: '#', label: 'Facebook' },
  { icon: Youtube, href: '#', label: 'Youtube' },
];

const quickLinks = [
  { label: 'Início', href: '#hero' },
  { label: 'Sobre', href: '#sobre' },
  { label: 'Cursos', href: '#cursos' },
  { label: 'Resultados', href: '#resultados' },
  { label: 'Depoimentos', href: '#depoimentos' },
  { label: 'Contato', href: '#contato' },
];

export const Footer = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer
      data-testid="footer"
      className="relative bg-dark-paper border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <motion.img
              src={LOGO_URL}
              alt="Ritha Barreto Academy"
              className="h-16 w-auto mb-6"
              whileHover={{ scale: 1.02 }}
            />
            <p className="text-white/60 text-sm leading-relaxed mb-6 max-w-md">
              A Ritha Barreto Academy é referência em formação profissional na área de estética avançada, 
              transformando vidas através da capacitação de excelência.
            </p>
            
            {/* Social Links */}
            <div className="flex gap-4">
              {socialLinks.map((social) => (
                <motion.a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/5 rounded-full flex items-center justify-center text-white/60 hover:text-gold hover:bg-gold/10 transition-all"
                  whileHover={{ scale: 1.1, y: -2 }}
                  whileTap={{ scale: 0.9 }}
                  data-testid={`footer-social-${social.label.toLowerCase()}`}
                >
                  <social.icon className="w-5 h-5" />
                </motion.a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-bold text-white mb-6">
              Links Rápidos
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-white/60 hover:text-gold transition-colors text-sm"
                    data-testid={`footer-link-${link.label.toLowerCase()}`}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-lg font-bold text-white mb-6">
              Contato
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="tel:+5521998384393"
                  className="text-white/60 hover:text-gold transition-colors"
                >
                  (21) 99838-4393
                </a>
              </li>
              <li>
                <a
                  href="mailto:contato@rithabarretoacademy.com"
                  className="text-white/60 hover:text-gold transition-colors"
                >
                  contato@rithabarretoacademy.com
                </a>
              </li>
              <li className="text-white/60">
                Rio de Janeiro, RJ
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="my-12 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />

        {/* Bottom */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-sm">
            © {currentYear} Ritha Barreto Academy. Todos os direitos reservados.
          </p>
          
          <p className="text-white/40 text-sm flex items-center gap-1">
            Feito com <Heart className="w-4 h-4 text-gold fill-gold" /> para transformar carreiras
          </p>
        </div>
      </div>
    </footer>
  );
};
